import React from 'react';

import css from './Popup.css';
import Notification from './Notification';
import { useCustomNotificationContext } from './context';

export default () => {
    const { userCustomNotifications, setFootRef } = useCustomNotificationContext();
    return (
        <div className={css.root} ref={setFootRef}>
            {userCustomNotifications.map(notification => (
                <Notification
                    key={notification._id || notification.id}
                    notification={notification}
                />
            ))}
        </div>
    );
};
